/*
    This file contains all the requests available for the part codes.
*/
import HttpService from "./http.service";

class PartCodeService {

    // Get all UIDs
    getParts = async () => {
        const endpoint = 'parts';
        return await HttpService.get(endpoint);
    };

    // Get one UID by id
    getPartById = async (id) => {
        const endpoint = `parts/${id}`;
        const result = await HttpService.get(endpoint);
        return result;
    };

    //Get a partcode's image
    getImage = async (imagePath) => {
        const encodedPath = encodeURIComponent(imagePath);
        const endpoint = `parts/getimage/${encodedPath}`;
        return await HttpService.get(endpoint);
    };

    // Get a partcode's file
    // filePath is the s3 key of the file
    getFile = async (filePath) => {
        const encodedPath = encodeURIComponent(filePath);
        const endpoint = `parts/getfile/${encodedPath}`;
        return await HttpService.get(endpoint);
    };

    // Get all children of a partcode
    getChildren = async (id) => {
        const endpoint = `parts/getchildren/${id}`;
        return await HttpService.get(endpoint);
    };

    // Get parts by status
    getPartsByStatus = async (status) => {
        const endpoint = `parts/status/${status}`;
        return await HttpService.get(endpoint);
    }

    /*
        Uploads a file to s3 bucket
        payload format : 
        {
            filename: string,  (Name of the file)
            dataUrl: string,   (Base64 data of the file)
            folderpath: string (Name of the folder in s3/partcodes where the file will be stored)
        } 
    */
    uploadFile = async (payload) => {
        const endpoint = 'parts/upload';
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        }
        return await HttpService.post(endpoint, payload, config);
    };

    // Delete file from s3 using its s3key
    deleteFile = async (s3key) => {
        const encodedPath = encodeURIComponent(s3key);
        const endpoint = `parts/deletefile/${encodedPath}`;
        return await HttpService.delete(endpoint);
    };

    // Create a new Part Code
    createPart = async (payload, image, files) => {
        const endpoint = 'parts';
        let formData = {};
        let paths = {};
        const config = {
            headers: {
                "Content-Type": "multipart/form-data",
            },
        };

        /*
            If the partcode has files, we first upload each of them individually to s3 
            Then we send the s3keys of the files to the create part endpoint
        */
        if (files) {
            await Promise.all(Object.entries(files).map(async ([filename, dataUrl]) => {
                // folderpath = path in s3 to the folder of the partcode
                // dataUrl = base64 data of the file
                // filename = filename with extension (e.g. myDocument.docx)
                const formData = {
                    data: {
                        type: "file",
                        attributes: {
                            filename: filename,
                            dataUrl: dataUrl,
                            folderpath: payload.data.attributes.folderpath
                        }
                    }
                };
                // Response is in format {s3key: path}
                const path = await this.uploadFile(formData);
                paths[filename] = path.s3Key;
            }));;
            formData = {
                data: payload.data,
                paths: paths
            };
            console.log("payload with files", formData);
        }
        /*
            If the partcode has an image, we directly upload it in the backend
        */
        if (image) {
            formData = {
                file: image,
                data: payload.data,
                paths: paths
            };
            console.log("payload with Image", formData);
        }
        if (!image && !files) {
            console.log("payload No Image No File", payload);
            return await HttpService.post(endpoint, payload);
        }
        console.log("formData", formData);
        return await HttpService.post(endpoint, formData, config);

    };

    // Edit a partcode's s3 keys
    updatePartKeys = async (payload, id) => {
        const endpoint = `parts/updatekeys/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Edit a UID
    editPart = async (payload, id) => {
        const endpoint = `parts/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    updateChildren = async (payload, id) => {
        const endpoint = `parts/updatechildren/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Delete a UID
    deletePart = async (id, userId) => {
        const endpoint = `parts/${id}/user/${userId}`;
        return await HttpService.delete(endpoint);
    };

    // Approve a UID
    approvePart = async (id) => {
        const endpoint = `parts/approve/${id}`;
        return await HttpService.patch(endpoint);
    };

    // Reject a Part Code
    rejectPart = async (id) => {
        const endpoint = `parts/reject/${id}`;
        return await HttpService.patch(endpoint);
    };

    // Get all parts awaiting approval
    getPartsAwaitingApproval = async () => {
        const endpoint = 'parts/approval/awaiting';
        return await HttpService.get(endpoint);
    };

    // Get available unique numbers for a given category
    getAvailableUniqueNumbers = async (categoryId) => {
        const endpoint = `parts/available/${categoryId}`;
        return await HttpService.get(endpoint);
    };

    // Get used part numbers for a given category
    getUsedPartNumbers = async () => {
        const endpoint = `parts/used/partnums`;
        return await HttpService.get(endpoint);
    };

    // Get a snapshot part based on unique_num, partCateogryId, and revNum
    getSnapshot = async (uniqueNum, partCategoryId, revNum) => {
        const endpoint = `parts/snapshot?uniqueNum=${uniqueNum}&partCategoryId=${partCategoryId}&revNum=${revNum}`;
        return await HttpService.get(endpoint);
    };

    // Archive a part code
    editStatus = async (id, payload) => {
        const endpoint = `parts/status/${id}`;
        return await HttpService.patch(endpoint, payload);
    };

    // Get all parts including archived and snapshot
    getAllParts = async () => {
        const endpoint = 'parts/all';
        return await HttpService.get(endpoint);
    }

}


export default new PartCodeService();